import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Flex, Divider, Text, ActionButton, DialogTrigger, Dialog, Heading, Content } from '@adobe/react-spectrum';
import ShowMenu from '@spectrum-icons/workflow/ShowMenu';
import './HeaderBar.css';
import { setAppRoute } from '../../data/redux/slices/appSlice';
import { getAnalytics, logEvent } from 'firebase/analytics';
import { getId, getInstallations } from 'firebase/installations';
import isMobile from 'ismobilejs';
import RealTimeCustomerProfile from '@spectrum-icons/workflow/RealTimeCustomerProfile';
import { useAuth } from 'react-oidc-context';
import { fetchUserDetails } from '../../data/redux/slices/userDetailsSlice';
import { fetchAuthorDetails } from '../../data/redux/slices/authorDetailsSlice';
import { AvatarImage } from '../avatarImage/AvatarImage';
import { NavLink } from '../common/NavLink';
import { TableFlipIcon } from '../common/TableFlipIcon';

export function HeaderBar(props) {
    const dispatch = useDispatch();
    // const auth = window.__auth; //useAuth();
    const auth = useAuth();

    const mobile = isMobile(window.navigator).phone;
    const title = useSelector((state) => state?.app?.title);
    const route = useSelector((state) => state?.app?.route);
    const profileName = useSelector((state) => state?.profile?.metadata?.profileName);
    const avatarUrl = useSelector((state) => state?.profile?.metadata?.avatarUri);

    let headerCaption = '';
    let headerTitle = route.path === '/profile' ? profileName : title;

    switch (route.path) {
        case '':
        case '/':
            headerCaption = 'Let that sweet salt flow!';
            break;
        case '/archetypes':
            headerCaption = 'All of the different ways to annoy your friends!';
            break;
        case '/card':
            headerCaption = '';
            break;
        case '/commanders':
            headerCaption = 'The saltier, the better!';
            break;
        case '/users':
            headerCaption = 'Who is the saltiest of them all?';
            break;
        case '/contact':
            headerCaption = 'File any grievances here';
            break;
        case '/faq':
            headerCaption = 'Eh? Why dis? Who dat?';
            break;
        case '/managedecks':
            headerCaption = 'Manage your decks';
            break;
        case '/changelog':
            headerCaption = 'Information about recent changes';
            break;
        default:
            headerCaption = '';
    }

    const handleDiscordBotLink = async () => {
        logEvent(getAnalytics(), 'install_bot_click');
        window.open(
            `https://discord.com/oauth2/authorize?client_id=1130881153998540800&permissions=2147483648&scope=bot`,
            `_blank`
        );
        const installations = getInstallations(window.firebaseApp);
    };

    const handleDiscordLink = async () => {
        logEvent(getAnalytics(), 'discord_click');
        window.open(`https://discord.gg/Yb2CAxcJcf`, `_blank`);
        const installations = getInstallations(window.firebaseApp);
    };

    const handleBlueSkyLink = async () => {
        logEvent(getAnalytics(), 'bluesky_click');
        window.open(`https://bsky.app/profile/commandersalt.bsky.social`, `_blank`);
        const installations = getInstallations(window.firebaseApp);
    };

    const handlePatreonLink = async () => {
        logEvent(getAnalytics(), 'patreon_click');
        window.open(
            `https://patreon.com/user?u=4796225&utm_medium=clipboard_copy&utm_source=copyLink&utm_campaign=creatorshare_creator&utm_content=join_link`,
            `_blank`
        );
        const installations = getInstallations(window.firebaseApp);
    };

    const handleHomeClick = async () => {
        dispatch(setAppRoute({ route: '/' }));
    };

    const handleNewsClick = async () => {
        dispatch(setAppRoute({ route: '/changelog' }));
    };

    const handleHeaderClick = (route) => {
        logEvent(getAnalytics(), `header_open_${route}`);
        dispatch(setAppRoute({ route }));
    };

    const handleMenuClick = (route, closeMethod) => {
        logEvent(getAnalytics(), `header_open_${route}`);
        dispatch(setAppRoute({ route }));
        closeMethod();
    };

    const [screenWidth, setScreenWidth] = React.useState(window.innerWidth);
    React.useEffect(() => {
        const handleResizeWindow = () => setScreenWidth(window.innerWidth);
        // subscribe to window resize event "onComponentDidMount"
        window.addEventListener('resize', handleResizeWindow);
        return () => {
            // unsubscribe "onComponentDestroy"
            window.removeEventListener('resize', handleResizeWindow);
        };
    }, []);

    const handleProfileClick = () => {
        logEvent(getAnalytics(), `header_open_profile`);
        dispatch(fetchUserDetails(profileName));
        dispatch(setAppRoute({ route: `/user/id/${encodeURIComponent(profileName)}` }));
    };

    const headerClassName = screenWidth < 1000 ? 'layered-image-mobile' : 'layered-image';

    return (
        <Flex direction={'row'} justifyContent={'center'}>
            <Flex direction="column" maxWidth={`100vw`} width={2000} alignItems="center">
                <Flex
                    direction="row"
                    width="100%"
                    // margin="5px"
                    justifyContent="space-between"
                    height="54px"
                    UNSAFE_style={{ backgroundColor: '#0e0e0e' }}
                >
                    <Flex direction={'row'}>
                        <NavLink to="/" style={{ display: 'block', textDecoration: 'none' }}>
                            <Flex direction="row" UNSAFE_style={{ marginTop: '10px' }}>
                                <img
                                    src="/resources/chef-kiss-header.png"
                                    width="30px"
                                    height="30px"
                                    alt="CommanderSalt.com - Your new source of inspiration for degenerate MtG Commander/EDH decks!"
                                    style={{ paddingLeft: '10px', paddingRight: '10px' }}
                                />
                                <Text UNSAFE_className="HeaderText">COMMANDERSALT.COM</Text>
                            </Flex>
                        </NavLink>
                        {screenWidth > 1000 && (
                            <Flex direction={'row'} marginTop={10} marginStart={50} columnGap={30} alignSelf={'start'}>
                                <Divider orientation={'vertical'} size={'S'} height={30} />
                                <NavLink
                                    to="/meta"
                                    className="navLinksHeader"
                                    onClick={() => logEvent(getAnalytics(), 'header_open_/meta')}
                                >
                                    cEDH META
                                </NavLink>
                                <NavLink
                                    to="/commanders"
                                    className="navLinksHeader"
                                    onClick={() => logEvent(getAnalytics(), 'header_open_/commanders')}
                                >
                                    COMMANDERS
                                </NavLink>
                                <NavLink
                                    to="/users"
                                    className="navLinksHeader"
                                    onClick={() => logEvent(getAnalytics(), 'header_open_/users')}
                                >
                                    USERS
                                </NavLink>
                                <NavLink
                                    to="/archetypes"
                                    className="navLinksHeader"
                                    onClick={() => logEvent(getAnalytics(), 'header_open_/archetypes')}
                                >
                                    ARCHETYPES
                                </NavLink>
                                <Divider orientation={'vertical'} size={'S'} height={30} />
                                <NavLink
                                    to="/changelog"
                                    className="navLinksHeader"
                                    onClick={() => logEvent(getAnalytics(), 'header_open_/changelog')}
                                >
                                    CHANGELOG
                                </NavLink>
                                <NavLink
                                    to="/faq"
                                    className="navLinksHeader"
                                    onClick={() => logEvent(getAnalytics(), 'header_open_/faq')}
                                >
                                    FAQ
                                </NavLink>
                                <a
                                    className="navLinksHeader"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => handleDiscordBotLink()}
                                >
                                    BOT
                                </a>
                            </Flex>
                        )}
                    </Flex>
                    <Flex direction={'row'}>
                        {screenWidth > 1000 && (
                            <Flex direction={'row'} marginTop={10} columnGap={10} marginRight={25}>
                                <ActionButton
                                    onPress={handlePatreonLink}
                                    aria-label="Support us on Patreon!"
                                    isQuiet={true}
                                    data-role="icon-circle-sm"
                                >
                                    <img src="/resources/patreon.png" alt="Patreon" />
                                </ActionButton>
                                <ActionButton
                                    onPress={handleBlueSkyLink}
                                    aria-label="Follow us on BlueSky!"
                                    isQuiet={true}
                                    data-role="icon-circle-sm"
                                >
                                    <img src="/resources/bluesky.png" alt="BlueSky" />
                                </ActionButton>
                                <ActionButton
                                    onPress={handleDiscordLink}
                                    aria-label="Join our Discord!"
                                    isQuiet={true}
                                    data-role="icon-circle-sm"
                                >
                                    <img src="/resources/discord.png" alt="Discord" />
                                </ActionButton>
                            </Flex>
                        )}
                        <span style={{ marginRight: '5px', alignSelf: 'center', paddingRight: 5 }}>
                            <span style={{ marginLeft: '5px', alignSelf: 'right' }}>
                                <DialogTrigger type="popover" mobileType="tray">
                                    <ActionButton isQuiet={true} data-role="icon-circle-sm">
                                        <AvatarImage size={25} avatarUrl={avatarUrl} showDefaultIcon={true} />
                                    </ActionButton>
                                    {(close) => (
                                        <Dialog>
                                            <Heading
                                                UNSAFE_style={{
                                                    fontSize: '1.2rem',
                                                    fontWeight: 'bolder',
                                                    color: 'red',
                                                }}
                                            >
                                                commandersalt
                                            </Heading>
                                            <Content minHeight="100vh">
                                                <Flex direction="column">
                                                    <Divider size={'S'} marginTop={20} />
                                                    {!auth?.isAuthenticated && !auth.isLoading && (
                                                        <Flex direction="column" marginTop={20}>
                                                            <nav
                                                                className="navLinks"
                                                                onClick={() => {
                                                                    close();
                                                                    void auth.signinRedirect();
                                                                }}
                                                            >
                                                                LOG IN / SIGN UP
                                                            </nav>
                                                            <NavLink
                                                                to="/verify-email"
                                                                className="navLinks"
                                                                onClick={() => close()}
                                                            >
                                                                VERIFY EMAIL
                                                            </NavLink>
                                                        </Flex>
                                                    )}
                                                    {auth.isAuthenticated && (
                                                        <Flex direction="column">
                                                            <Heading
                                                                UNSAFE_style={{
                                                                    fontSize: '1.3rem',
                                                                    fontWeight: 'bolder',
                                                                    color: '#b0eaff',
                                                                }}
                                                            >
                                                                {profileName}
                                                            </Heading>
                                                            <NavLink
                                                                to={`/user/id/${encodeURIComponent(profileName)}`}
                                                                className="navLinks"
                                                                onClick={() => {
                                                                    close();
                                                                    logEvent(getAnalytics(), 'header_open_profile');
                                                                    dispatch(fetchUserDetails(profileName));
                                                                }}
                                                            >
                                                                PROFILE
                                                            </NavLink>
                                                            <NavLink
                                                                to="/linkedaccounts"
                                                                className="navLinks"
                                                                onClick={() => {
                                                                    close();
                                                                    logEvent(
                                                                        getAnalytics(),
                                                                        'header_open_/linkedaccounts'
                                                                    );
                                                                }}
                                                            >
                                                                LINKED ACCOUNTS
                                                            </NavLink>
                                                            <NavLink
                                                                to="/managedecks"
                                                                className="navLinks"
                                                                onClick={() => {
                                                                    close();
                                                                    logEvent(
                                                                        getAnalytics(),
                                                                        'header_open_/managedecks'
                                                                    );
                                                                }}
                                                            >
                                                                MANAGE DECKS
                                                            </NavLink>
                                                            <NavLink
                                                                to="/settings"
                                                                className="navLinks"
                                                                onClick={() => {
                                                                    close();
                                                                    logEvent(getAnalytics(), 'header_open_/settings');
                                                                }}
                                                            >
                                                                SETTINGS
                                                            </NavLink>
                                                            <a
                                                                className="navLinks"
                                                                style={{ cursor: 'pointer' }}
                                                                onClick={() => {
                                                                    close();
                                                                    void auth.signoutSilent();
                                                                    window.signOutRedirect();
                                                                    // void auth.signoutRedirect();
                                                                }}
                                                            >
                                                                LOG OUT
                                                            </a>
                                                            <Divider marginTop={10} marginBottom={10} size={'S'} />
                                                        </Flex>
                                                    )}
                                                    {screenWidth < 1000 && (
                                                        <Flex direction="column">
                                                            <NavLink
                                                                to="/"
                                                                className="navLinks"
                                                                onClick={() => {
                                                                    close();
                                                                    logEvent(getAnalytics(), 'header_open_/');
                                                                }}
                                                            >
                                                                LEADERBOARD
                                                            </NavLink>
                                                            <NavLink
                                                                to="/commanders"
                                                                className="navLinks"
                                                                onClick={() => {
                                                                    close();
                                                                    logEvent(getAnalytics(), 'header_open_/commanders');
                                                                }}
                                                            >
                                                                COMMANDERS
                                                            </NavLink>
                                                            <NavLink
                                                                to="/users"
                                                                className="navLinks"
                                                                onClick={() => {
                                                                    close();
                                                                    logEvent(getAnalytics(), 'header_open_/users');
                                                                }}
                                                            >
                                                                USERS
                                                            </NavLink>
                                                            <NavLink
                                                                to="/archetypes"
                                                                className="navLinks"
                                                                onClick={() => {
                                                                    close();
                                                                    logEvent(getAnalytics(), 'header_open_/archetypes');
                                                                }}
                                                            >
                                                                ARCHETYPES
                                                            </NavLink>
                                                            <Divider marginTop={10} marginBottom={10} size={'S'} />
                                                            <NavLink
                                                                to="/meta"
                                                                className="navLinks"
                                                                onClick={() => {
                                                                    close();
                                                                    logEvent(getAnalytics(), 'header_open_/meta');
                                                                }}
                                                            >
                                                                cEDH META
                                                            </NavLink>
                                                        </Flex>
                                                    )}
                                                    <NavLink
                                                        to="/powerlevels"
                                                        className="navLinks"
                                                        onClick={() => {
                                                            close();
                                                            logEvent(getAnalytics(), 'header_open_/powerlevels');
                                                        }}
                                                    >
                                                        POWER LEVELS
                                                    </NavLink>
                                                    <NavLink
                                                        to="/algorithm"
                                                        className="navLinks"
                                                        onClick={() => {
                                                            close();
                                                            logEvent(getAnalytics(), 'header_open_/algorithm');
                                                        }}
                                                    >
                                                        THE ALGORITHM
                                                    </NavLink>
                                                    <Divider marginTop={10} marginBottom={10} size={'S'} />
                                                    {screenWidth < 1000 && (
                                                        <Flex direction="column">
                                                            <NavLink
                                                                to="/changelog"
                                                                className="navLinksSubSection"
                                                                onClick={() => {
                                                                    close();
                                                                    logEvent(getAnalytics(), 'header_open_/changelog');
                                                                }}
                                                            >
                                                                - CHANGELOG
                                                            </NavLink>
                                                            <NavLink
                                                                to="/faq"
                                                                className="navLinksSubSection"
                                                                onClick={() => {
                                                                    close();
                                                                    logEvent(getAnalytics(), 'header_open_/faq');
                                                                }}
                                                            >
                                                                - FAQ
                                                            </NavLink>
                                                            <Divider marginTop={10} marginBottom={10} size={'S'} />
                                                        </Flex>
                                                    )}
                                                    {screenWidth < 1000 && (
                                                        <Flex direction={'row'} marginBottom={20} columnGap={10}>
                                                            <ActionButton
                                                                onPress={handleDiscordBotLink}
                                                                aria-label="Download the Discord bot!"
                                                                isQuiet="true"
                                                                data-role="icon-circle-sm"
                                                            >
                                                                <img src="/resources/discordBot.png" />
                                                            </ActionButton>
                                                            <ActionButton
                                                                onPress={handlePatreonLink}
                                                                aria-label="Support us on Patreon!"
                                                                isQuiet="true"
                                                                data-role="icon-circle-sm"
                                                            >
                                                                <img src="/resources/patreon.png" />
                                                            </ActionButton>
                                                            <ActionButton
                                                                onPress={handleBlueSkyLink}
                                                                aria-label="Follow us on BlueSky!"
                                                                isQuiet="true"
                                                                data-role="icon-circle-sm"
                                                            >
                                                                <img src="/resources/bluesky.png" />
                                                            </ActionButton>
                                                            <ActionButton
                                                                onPress={handleDiscordLink}
                                                                aria-label="Join our Discord!"
                                                                isQuiet="true"
                                                                data-role="icon-circle-sm"
                                                            >
                                                                <img src="/resources/discord.png" />
                                                            </ActionButton>
                                                        </Flex>
                                                    )}
                                                    <span style={{ minHeight: 50 }} />
                                                </Flex>
                                            </Content>
                                        </Dialog>
                                    )}
                                </DialogTrigger>
                            </span>
                        </span>
                    </Flex>
                </Flex>
                <div className={`${headerClassName} headerBannerWrap`}>
                    <div className="leaderboard-title" data-eyebrow={headerCaption}>
                        {headerTitle}
                    </div>
                    <TableFlipIcon width={screenWidth < 1000 ? 140 : 260} color="#ffffff" className="headerTableFlip" />
                </div>
            </Flex>
        </Flex>
    );
}
